import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { queryClient } from './query/client';
import { QueryPersistenceProvider } from './query/persist';
import { trackEvent } from './analytics';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then()
      .catch(err => console.error('SW registration failed:', err));
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));

trackEvent('app_load', { path: typeof window !== 'undefined' ? window.location.pathname : undefined });

root.render(
  <React.StrictMode>
    <QueryPersistenceProvider client={queryClient}>
      <App />
    </QueryPersistenceProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  trackEvent('core_web_vital', {
    name: metric?.name,
    value: metric?.value,
    id: metric?.id,
    label: metric?.label,
  });
});
